<script lang="ts">
  import type { PageData } from "./$types";
  import { _ } from "svelte-i18n";
  import { navTheme } from "$lib/stores/navTheme";
  import ErrorPage from "$lib/layouts/ErrorPage/ErrorPage.svelte";
  import HomePage from "$lib/layouts/HomePage/HomePage.svelte";
  import DataLayer from "$lib/components/GTM/DataLayer.svelte";
  import HeightSkeleton from "$lib/components/HeightSkeleton/HeightSkeleton.svelte";

  export let data: PageData;
  $: page = data?.pageData?.data?.Page;
  $: navTheme.set(page?.theme);
</script>

{#if data.pageData && data.pageData.loading}
  <HeightSkeleton />
{:else if page}
  <HomePage pageData={page} />
  <DataLayer
    data={{
      pageType: "HOME",
      categoryName: "",
      categoryID: "",
      breadcrumb: ["Home"],
      ecommerce: null,
    }}
  />
{:else}
  <ErrorPage code={404} />
{/if}
